import { render } from "./Spinner.vue?vue&type=template&id=fbf81524&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=fbf81524&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fbf81524"

export default script